import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { Link } from 'react-router-dom';
import { translate } from 'react-admin';

import CardIcon from './CardIcon';

const styles = theme => ({
    main: {
        flex: '1',
        marginLeft: '1em',
        marginTop: 20,
    },
    card: {
        padding: '16px 0',
        overflow: 'inherit',
        textAlign: 'right' as 'right',
    },
    title: {
        padding: '0 16px',
    },
    value: {
        padding: '0 16px',
        minHeight: 48,
    },
    avatar: {
        background: theme.palette.background.avatar,
    },
    listItemText: {
        paddingRight: 0,
    },
});

const StatsTopTagAssets = ({ title, prefix, icon, tags, nb, translate, classes }) => (
    <div className={classes.main}>
        <CardIcon Icon={icon} bgColor="#4caf50" />
        <Card className={classes.card}>
            <Typography className={classes.title} color="textSecondary">
                {title}
            </Typography>
            <Typography
                variant="h2"
                component="h2"
                className={classes.value}
            >
                {nb}
            </Typography>
            <Divider />
            <List>
                {tags && tags.map(record => (
                    <ListItem
                        button
                        to={`/${prefix}?filter={"tags":[{"label":"${record.tag}","value":${record.id}}],"orientation":["any"],"type":["image"],"timeWhenValue":{"label":"Any","value":"any"},"deleted":false}&order=DESC&page=1&perPage=12&sort=id`}
                        component={Link}
                        key={record.id}
                    >
                        <ListItemText
                            primary={`${record.tag} (${record.total})`}
                            className={classes.listItemText}
                        />
                    </ListItem>
                ))}
            </List>
        </Card>
    </div>
);

const enhance = compose(
    withStyles(styles),
    translate
);

export default enhance(StatsTopTagAssets);
